import {Button, Stack, Typography} from "@mui/material";
import {ReactNode} from "react";

interface IActionButtonProps {
    icon: ReactNode;
    label: string;
    onClick: () => void;
}

export const ActionButton = ({icon, label, onClick}: IActionButtonProps) => {
    return (
        <Button
            onClick={onClick}
            variant="contained"
            sx={{
                width: '100%',
                height: '50px',
                borderRadius: '24px',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                boxShadow: '0 5px 10px rgba(0, 0, 0, 0.3)',
                // border: '1px solid rgba(255, 255, 255, 0.1)',
                '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',

                },
            }}
        >
            <Stack direction="row" alignItems="center" spacing={1} >
                {icon}
                <Typography variant="body2" sx={{textTransform: 'none', fontWeight: '600'}}>
                    {label}
                </Typography>
            </Stack>
        </Button>
    );
};
